import {
    SET_GLOBAL_VAR
  } from "../actions/types";

 
  export default function rootReducer(state = {}, action) {
    
    switch (action.type) {
      case SET_GLOBAL_VAR:
        return {...state, ...action.varObj}
      default:
        return state;
    };
  };